import {urlStringToObject} from "../mixins/urls";

const axios = require('axios');

class Api {
  static status() {
    return this.get().then(res => {
      if (window.user.signedIn() && res.data.signed_in === false) {
        window.user.deleteToken();
        window.location.href = "/";
      }

      return res;
    })
  }

  static get(endpoint, params={}) {
    let url = [process.env["REACT_APP_API_URL"], (params.version || process.env["REACT_APP_API_VERSION"]), endpoint].join("/");
    delete(params.version);

    if (url[url.length - 1] === "/") {
      url = url.substring(0, url.length - 1);
    }

    return axios
      .get(url, {
        params: Object.assign(Api.defaultParams(), params),
        headers: Api.defaultHeaders()
      })
      .then(res => {
        if (res.data.util && res.data.util.signed_in === false) {
          window.user.deleteToken();
        }

        return res;
      })
      .catch((e) => {
        window.dispatchEvent(new CustomEvent('apiError', { detail: { error: e }}));
        return Promise.reject(e)
      });
  }

  static post(endpoint, params={}) {
    let url = [process.env["REACT_APP_API_URL"], (params.version || process.env["REACT_APP_API_VERSION"]), endpoint].join("/");

    return axios.post(url, Object.assign(this.defaultParams(), params), {
      headers: this.defaultHeaders()
    }).catch((e) => {
      return Promise.reject(e)
    });
  }

  static delete(endpoint, opts={}) {
    let url = [process.env["REACT_APP_API_URL"], process.env["REACT_APP_API_VERSION"], endpoint].join("/");

    return axios.delete(url, Object.assign(this.defaultParams(), opts), {
      headers: this.defaultHeaders()
    }).then(res => {
      window.user.deleteToken();
      return res;
    })
  }

  static defaultParams() {
    let values = {
      token: process.env["REACT_APP_API_TOKEN"]
    };

    if (process.env.NODE_ENV === "development") {
      values.cb = Math.random()
    }

    const params = urlStringToObject(window.location.search.substr(1));
    values = Object.assign(params, values);

    return values;
  }

  static defaultHeaders() {
    let headers = {
      identifier: window.user.getIdentifier()
    };

    let token = window.user.token;
    if (!token) {
      return headers;
    }

    if (!token.includes("Bearer")) {
      token = "Bearer " + token;
    }

    if (token.includes("Bearer+")) {
      token = token.replace("Bearer+", "Bearer ");
    }

    headers.Authorization = token;

    return headers;
  }

  static buildUrl(endpoint) {
    return [process.env["REACT_APP_API_URL"], process.env["REACT_APP_API_VERSION"], endpoint].join("/");
  }
}

export default Api